import {createFeatureI18n} from '@/i18n/createFeatureI18n';
import et from './locales/et.json';
import en from './locales/en.json';
import ru from './locales/ru.json';

/**
 * Announcement message keys are not known at compile time — they arrive from the server and can
 * come from any feature. So this bundle is keyed by plain string rather than a literal union, and
 * an unlisted key falls through to the key name.
 *
 * Every feature that raises an announcement adds its key here with an empty value; the DB owns the
 * wording and /sync-translations fills it in.
 */
export function useAnnouncementsI18n() {
    return createFeatureI18n<Record<string, string>>({
        et: et as Record<string, string>,
        en: en as Record<string, string>,
        ru: ru as Record<string, string>,
    });
}
